import React from "react";
import { TouchableOpacity } from "react-native";
import Svg, { Path, Defs, LinearGradient, Stop, Rect, G, ClipPath } from "react-native-svg";

export default function IntegrationsIconGradient(props) {
  return (
    <TouchableOpacity style={props.style} {...props}>
      <Svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <G clipPath="url(#clip0_integrations)">
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.18556 4.76016C7.47298 4.4821 7.48058 4.02369 7.20252 3.73626C6.92447 3.44884 6.46605 3.44124 6.17863 3.7193L3.06861 6.72794C2.92288 6.86892 2.84293 7.06456 2.84822 7.26726C2.85351 7.46996 2.94356 7.66116 3.09645 7.79435L6.38387 10.6582C6.68541 10.9209 7.1428 10.8894 7.40548 10.5878C7.66816 10.2863 7.63667 9.82889 7.33513 9.5662L5.28537 7.78057H16.4284C16.8283 7.78057 17.1525 7.45638 17.1525 7.05647C17.1525 6.65656 16.8283 6.33237 16.4284 6.33237H5.56037L7.18556 4.76016ZM2.84779 12.6285C2.84779 12.2286 3.17198 11.9044 3.57189 11.9044H14.7151L12.6653 10.1187C12.3637 9.85602 12.3322 9.39863 12.5949 9.09709C12.8576 8.79555 13.315 8.76406 13.6165 9.02674L16.904 11.8906C17.0569 12.0238 17.1469 12.2149 17.1522 12.4176C17.1575 12.6204 17.0775 12.816 16.9318 12.957L13.8218 15.9656C13.5344 16.2437 13.0759 16.2361 12.7979 15.9486C12.5198 15.6612 12.5274 15.2028 12.8149 14.9248L14.44 13.3526H3.57189C3.17198 13.3526 2.84779 13.0284 2.84779 12.6285Z"
            fill="url(#paint0_linear_integrations)"
          />
        </G>
        <Defs>
          <LinearGradient
            id="paint0_linear_integrations"
            x1="2.84779"
            y1="6.25979"
            x2="8.47231"
            y2="19.252"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#05858A" />
            <Stop offset="1" stopColor="#2AE8CB" />
          </LinearGradient>
          <ClipPath id="clip0_integrations">
            <Rect
              width="14.6667"
              height="13.0157"
              fill="white"
              transform="translate(2.66666 3.33398)"
            />
          </ClipPath>
        </Defs>
      </Svg>
    </TouchableOpacity>
  );
}
